<template>
  <div class="issue-status-table-cell" v-if='item && item.status'>
    <!-- Suppressed / temporary exception render like any other status; details live in the issue dialog. -->
    <centralized-issue-status :status='item.status' compact/>
  </div>
</template>

<script>
import CentralizedIssueStatus from '@/components/common/CentralizedIssueStatus.vue';

export default {
  name: 'IssueStatusTableCell',
  components: { CentralizedIssueStatus },
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.issue-status-table-cell{
  display: flex;
  flex-direction: row;
}
</style>
